import React from "react"
import PropTypes from "prop-types"
import { toMoney } from "../../utils/string_utils"
import Button from "../shared/button/text-button"
import Tooltip from "../shared/tooltip/tooltip"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import "./extra.scss"
import { useMedia } from "hooks/use-media"
import { useSelector } from "react-redux"
import { isHaloExtraAdded } from "redux/selectors/basket-selectors"

library.add(faCheck)

const FlexWrapper = ({ children }) => (
  <div className="extra--phone-wrapper">{children}</div>
)

FlexWrapper.propTypes = {
  children: PropTypes.object
}

// Component to display an individual Extra line with add/remove buttons
const Extra = ({
  text,
  shortText,
  cost,
  hoverText,
  onAddExtra,
  onRemoveExtra,
  id,
  selectedExtraIDs,
  excludeVAT
}) => {
  const PriceButtonWrapper = useMedia(
    ["(max-width: 600px)"],
    [FlexWrapper],
    ({ children }) => <>{children}</>
  )

  const haloExtraHasBeenAdded = useSelector(isHaloExtraAdded)

  let isExtraDisabled = false

  if (haloExtraHasBeenAdded) {
    if (id === "HYBRID_HUB" || id === "COMPLETE_WIFI") {
      isExtraDisabled = true
    }
  }

  return (
    <div className="extra">
      <div className="description">
        <div className="short-text">
          {shortText} {hoverText && <Tooltip text={hoverText} />}
        </div>
        {text && (
          <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
        )}
      </div>
      <PriceButtonWrapper>
        {cost ? (
          <div className="cost">
            <div className="value">{toMoney(cost)}</div>
            <div className="label">monthly</div>
            {excludeVAT && <div className="vatDescription">(exc. VAT)</div>}
          </div>
        ) : (
          <div className="cost">
            <div className="value">Free</div>
          </div>
        )}
        {selectedExtraIDs.indexOf(id) < 0 ? (
          isExtraDisabled ? (
            <div className="add-extra-button">
              <Button text="Already in Halo 3" onClick={() => {}} />
            </div>
          ) : (
            <div className="add-extra-button">
              <Button
                text="Add"
                onClick={() => {
                  onAddExtra(id)
                }}
              />
            </div>
          )
        ) : (
          <div className="remove-extra-button">
            <div className="added-message">
              <FontAwesomeIcon icon="check" /> Added
            </div>
            <div className="remove-link">
              <div onClick={() => onRemoveExtra(id)}>Remove this extra</div>
            </div>
          </div>
        )}
      </PriceButtonWrapper>
    </div>
  )
}

Extra.propTypes = {
  text: PropTypes.string,
  shortText: PropTypes.string.isRequired,
  cost: PropTypes.number.isRequired,
  hoverText: PropTypes.string,
  onAddExtra: PropTypes.func.isRequired,
  onRemoveExtra: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  selectedExtraIDs: PropTypes.arrayOf(PropTypes.string),
  excludeVAT: PropTypes.bool
}

Extra.defaultProps = {
  text: "",
  hoverText: "",
  selectedExtraIDs: [],
  excludeVAT: false
}

export default Extra
